import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import Header from '../../components/Header/header'
import Sidebar from '../../components/Sidebar/Sidebar'
import { Grid, Content } from '../../components/Layout'
import { areaFdsActions } from '../../actions'
import { PdfIcon } from '../../components/icons'
import { Input, ReloadButton } from '../../components/Form'
import { SimpleLoader, WrapperLoader } from '../../components/loaders'
import ContentHeader from '../../components/ContentHeader'
import Message from '../../components/PageMessage'
import { pxToRem, color, normalize } from '../../utils'

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || ''

const Search = styled.div`
  background-color: #FFF;
  padding: 10px 20px 20px;
  margin-bottom: ${pxToRem(20)};
`

const List = styled.ul`
  padding: 0;
  margin: 0;
  background-color: #FFF;
`

const Item = styled.li`
  list-style-type: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 20px;
  border-bottom: 1px solid #d8d8d8;

  &:last-child {
    border-bottom: none;
  }

  p {
    margin: 0;
  }

  @media only screen and (max-width: 550px) {
    flex-direction: column;
    align-items: stretch;
  }
`

const ProductName = styled.p`
  color: ${color.secondary};
  font-weight: bold;
  text-transform: uppercase;
`

const Details = styled.p`
  color: #5b666d;
  font-size: ${pxToRem(14)};
`

const ExpiredBadge = styled.span`
  display: inline-block;
  margin-left: 8px;
  padding: 2px 8px;
  border-radius: 4px;
  background-color: #d0021b;
  color: #FFF;
  font-size: ${pxToRem(12)};
  font-weight: bold;
  text-transform: uppercase;
`

const OpenFds = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex-shrink: 0;
  padding: 10px 16px;
  border-radius: 4px;
  background-color: ${color.primary};
  color: #FFF;
  font-weight: bold;
  text-decoration: none;

  &:hover {
    color: #FFF;
    text-decoration: none;
  }
`

class AreaFds extends Component {
  state = {
    search: ''
  }

  componentDidMount() {
    this.fetch()
  }

  fetch = () => {
    this.props.fetchAreaFds(this.props.router.match.params.token)
  }

  changeSearch = event => {
    this.setState({ search: event.target.value })
  }

  renderError() {
    if (this.props.error === 'invalid') {
      return (
        <Message>
          <strong>QR Code inválido ou expirado.</strong>
          <span>Solicite ao responsável pela área um novo QR Code de FDS.</span>
        </Message>
      )
    }

    return (
      <Message>
        <strong>Falha ao carregar as FDS desta área.</strong>

        <ReloadButton onClick={this.fetch} />
      </Message>
    )
  }

  renderList() {
    const { fds } = this.props

    if (fds.length === 0) {
      return (
        <Message>
          <strong>Não há FDS cadastradas para esta área.</strong>
        </Message>
      )
    }

    // busca sem diferenciar maiúsculas nem acentos ("acido" encontra "ÁCIDO")
    const term = normalize(this.state.search)
    const filtered = term ? fds.filter(item => normalize(item.name).includes(term)) : fds

    return (
      <Fragment>
        <Search>
          <Input
            label="Buscar produto"
            value={this.state.search}
            onChange={this.changeSearch}
          />
        </Search>

        {filtered.length === 0 ? (
          <Message>
            <strong>Nenhum produto encontrado para "{this.state.search}".</strong>
          </Message>
        ) : (
          <List>
            {filtered.map(item => (
              <Item key={item.id}>
                <div>
                  <ProductName>
                    {item.name}
                    {item.expired && <ExpiredBadge>Vencida</ExpiredBadge>}
                  </ProductName>
                  {item.provider && <Details>Fornecedor: {item.provider}</Details>}
                  <Details>
                    Emissão: {item.fispq_issue_date || '---'}
                    {' · '}
                    Atualização: {item.fispq_update_date || '---'}
                  </Details>
                  <Details>Validade: {item.fispq_expiration_date || '---'}</Details>
                </div>

                <OpenFds
                  href={`${API_BASE_URL}${item.document_url}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <PdfIcon color="#FFF" />
                  Abrir FDS
                </OpenFds>
              </Item>
            ))}
          </List>
        )}
      </Fragment>
    )
  }

  renderContent() {
    const { loading, error, area, fds } = this.props

    if (loading) {
      return (
        <WrapperLoader>
          <SimpleLoader />
        </WrapperLoader>
      )
    }

    if (error) return this.renderError()

    const code = (area.code || '').trim()
    const areaLabel = code ? `${code} - ${area.name}` : area.name

    return (
      <Fragment>
        <ContentHeader
          title={`FDS da área: ${areaLabel}`}
          subtitle={`${fds.length} ${fds.length === 1 ? 'FDS disponível' : 'FDS disponíveis'}`}
        />
        {this.renderList()}
      </Fragment>
    )
  }

  render() {
    const { menuItems = [], router, accessToken } = this.props

    return (
      <Grid>
        <Header router={router} />
        {accessToken && <Sidebar menuItems={menuItems} router={router} />}
        <Content>{this.renderContent()}</Content>
      </Grid>
    )
  }
}

const mapStateToProps = state => ({
  loading: state.areaFds.loading,
  error: state.areaFds.error,
  area: state.areaFds.area,
  fds: state.areaFds.fds,
  accessToken: state.headers.accessToken
})

const mapDispatchToProps = dispatch => ({
  fetchAreaFds: token => {
    dispatch(areaFdsActions.fetchAreaFds(token))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(AreaFds)



// WEBPACK FOOTER //
// ./src/containers/AreaFds/AreaFds.js